<template>
  <v-layout>
    <slot name="prepend-area" />
    <v-text-field
      v-model.number="inputValue"
      :prepend-icon="prependIcon"
      :rules="rules"
      :disabled="disabled"
      :class="{ disabled: disabled }"
      @keydown.arrow-down.prevent
      @keydown.arrow-up.prevent
      @wheel.prevent
      type="number"
      class="withoutSpinButton"
    >
      <template v-slot:prepend>
        <slot name="prepend" />
      </template>
      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
    </v-text-field>
    <slot name="append-area" />
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    prependIcon: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    overZero: {
      type: Boolean,
      default: false,
    },
    overOne: {
      type: Boolean,
      default: false,
    },
    integer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rulesConst: {
        required: value =>
          Boolean(value !== undefined && value !== '') || '入力して下さい',
        overZero: value => Number(value) >= 0 || '0以上の数値を入力して下さい',
        overOne: value => Number(value) > 0 || '1以上の数値を入力して下さい',
        integer: value =>
          Number.isInteger(Number(value)) || '整数で入力して下さい',
      },
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', Number(val))
      },
    },
    rules() {
      let result = []
      Object.keys(this.rulesConst).forEach(ruleName => {
        if (this[ruleName]) {
          result.push(this.rulesConst[ruleName])
        }
      })
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  ::v-deep .v-input__slot {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
.withoutSpinButton {
  ::v-deep input[type='number'] {
    -moz-appearance: textfield;
  }

  ::v-deep input[type='number']::-webkit-outer-spin-button,
  ::v-deep input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}
</style>
